import React, { useEffect, useState } from 'react';

//Funciones y librerias
import { estilos2 } from '../../Lib/estilosCuentaRegresiva';

//Pistas
import { pistasNutricion, pistasNutricion4} from '../../Lib/listaPistas';
import { pistasNutricion2 } from '../../Lib/listaPistas';
import { pistasNutricion3 } from '../../Lib/listaPistas';


//Estilos
import '../../styles/pistas.css';

//Imagenes
import botonDeSalir from '../../imgs/otros/eliminar.png';

//Componentes
import CuentaAtrasPista from './CuentaAtrasPista';


export default function Pistas(props) {
    let colorGradiante = estilos2[Math.floor((Math.random() * 30) + 1)];
    const [tamañoFuente, setTamañoFuente] = useState("2vw");

    const { temaElegido } = props;


    const cerrarPista = () => {
        props.fTemporizadorPistas(false);
    }



    const elegirPista = () => {
        let pistaElegida;

        console.log("temaElegido", temaElegido);

        if(temaElegido === "Nutrición"){
            const randomValuePista = Math.floor((Math.random() * pistasNutricion.length));

            console.log(randomValuePista,"randomValuePista");
            pistaElegida = pistasNutricion[randomValuePista].pista;
            console.log(pistasNutricion[randomValuePista].pista, "pista post random");
        }else if(temaElegido === "Nutrición-2"){
            const randomValuePista = Math.floor((Math.random() * pistasNutricion2.length));
            console.log(randomValuePista,"randomValuePista");
            pistaElegida = pistasNutricion2[randomValuePista].pista;
            console.log(pistasNutricion2[randomValuePista].pista, "pista post random");
        }else if(temaElegido === "Nutrición-3"){
            const randomValuePista = Math.floor((Math.random() * pistasNutricion3.length));
            console.log(randomValuePista,"randomValuePista");
            pistaElegida = pistasNutricion3[randomValuePista].pista;
            console.log(pistasNutricion3[randomValuePista].pista, "pista post random");
        }else if(temaElegido === "Nutrición-4"){
            const randomValuePista = Math.floor((Math.random() * pistasNutricion4.length));
            console.log(randomValuePista,"randomValuePista");
            pistaElegida = pistasNutricion4[randomValuePista].pista;
            console.log(pistasNutricion4[randomValuePista].pista, "pista post random");
        }


        return pistaElegida
    }

    console.log("pista elegida", elegirPista());

let pistaRender = elegirPista();

useEffect(() => {
    if(pistaRender.length > 100){
        setTamañoFuente("1.5vw");
    }
}, [])



    return (
        <div className="pistas__div--container">
            <div className="pistas__div--cajon" style={{background: `linear-gradient(-45deg, ${colorGradiante} 50%, rgba(255, 255, 255) 50%)`}}>
                <CuentaAtrasPista temporizadorPistas={props.temporizadorPistas} fTemporizadorPistas={props.fTemporizadorPistas}/>
                <img className='pista__img--cerrarPista' onClick={() => cerrarPista()} src={botonDeSalir} alt='salir.png'/>
                <h2 className="pistas__h2--pistas">Pista</h2>
                <div className='pistas__div--pista' style={{fontSize: tamañoFuente}}>{pistaRender}</div>
            </div>
        </div>
    )
}
